/**
 * @generated SignedSource<<4d15f3b0debee576ea18a0efa40dc50d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
export type StreamAccessType = "full" | "partial" | "shared";
export type MergeStreamQuery$variables = {
  eventTitle?: string | null;
  includeExternal?: boolean | null;
  includeOneOnOnes?: boolean | null;
  streamId: string;
};
export type MergeStreamQuery$data = {
  readonly noteStreamsSearch: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly displayName: string;
        readonly id: string;
        readonly isExternal: boolean;
        readonly notesCountForViewer: number;
        readonly notestreamusers: ReadonlyArray<{
          readonly user: {
            readonly email: string;
            readonly fullName: string;
            readonly id: string;
            readonly image: string;
            readonly isActive: boolean;
            readonly isConfigured: boolean;
            readonly isExternal: boolean;
            readonly isGuest: boolean;
          };
        }>;
        readonly type: NoteStreamType;
        readonly userCount: number;
        readonly viewerNotestreamuser: {
          readonly accessType: StreamAccessType;
        } | null;
      } | null;
    } | null>;
  } | null;
};
export type MergeStreamQuery = {
  response: MergeStreamQuery$data;
  variables: MergeStreamQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventTitle"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeExternal"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeOneOnOnes"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "streamId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "eventTitle",
    "variableName": "eventTitle"
  },
  {
    "kind": "Variable",
    "name": "includeExternal",
    "variableName": "includeExternal"
  },
  {
    "kind": "Variable",
    "name": "includeOneOnOnes",
    "variableName": "includeOneOnOnes"
  },
  {
    "kind": "Variable",
    "name": "streamId",
    "variableName": "streamId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notesCountForViewer",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accessType",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCount",
  "storageKey": null
},
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isConfigured",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGuest",
      "storageKey": null
    },
    (v9/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MergeStreamQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "NoteStreamConnection",
        "kind": "LinkedField",
        "name": "noteStreamsSearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStreamEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteStreamUser",
                    "kind": "LinkedField",
                    "name": "viewerNotestreamuser",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": (v12/*: any*/),
                    "concreteType": "NoteStreamUser",
                    "kind": "LinkedField",
                    "name": "notestreamusers",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/)
                    ],
                    "storageKey": "notestreamusers(first:3)"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "MergeStreamQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "NoteStreamConnection",
        "kind": "LinkedField",
        "name": "noteStreamsSearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStreamEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteStreamUser",
                    "kind": "LinkedField",
                    "name": "viewerNotestreamuser",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": (v12/*: any*/),
                    "concreteType": "NoteStreamUser",
                    "kind": "LinkedField",
                    "name": "notestreamusers",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": "notestreamusers(first:3)"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "76921658da2d44d425264b2faa9070b6",
    "id": null,
    "metadata": {},
    "name": "MergeStreamQuery",
    "operationKind": "query",
    "text": "query MergeStreamQuery(\n  $eventTitle: String\n  $streamId: ID!\n  $includeOneOnOnes: Boolean\n  $includeExternal: Boolean\n) {\n  noteStreamsSearch(eventTitle: $eventTitle, streamId: $streamId, includeOneOnOnes: $includeOneOnOnes, includeExternal: $includeExternal) {\n    edges {\n      node {\n        id\n        type\n        displayName\n        notesCountForViewer\n        isExternal\n        viewerNotestreamuser {\n          accessType\n          id\n        }\n        userCount\n        notestreamusers(first: 3) {\n          user {\n            id\n            email\n            image\n            fullName\n            isActive\n            isConfigured\n            isGuest\n            isExternal\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5f00ec4c57514fd2ab78595b800ec653";

export default node;
